import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PagosForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Pagos"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.inscripcionId}>            
                              <label  >{strings?strings["inscripcionId"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["inscripcionId"]:""} 
                                    name="inscripcionId"
                                    onChange={onChange}
                                    value={datos.inscripcionId}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.montoPago}>            
                              <label  >{strings?strings["montoPago"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["montoPago"]:""} 
                                    name="montoPago"
                                    onChange={onChange}
                                    value={datos.montoPago}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.referencia}>            
                              <label  >{strings?strings["referencia"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["referencia"]:""} 
                                    name="referencia"
                                    onChange={onChange}
                                    value={datos.referencia}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.fechaPago}>            
                              <label  >{strings?strings["fechaPago"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["fechaPago"]:""} 
                                    name="fechaPago"
                                    onChange={onChange}
                                    value={datos.fechaPago}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.pagado}>            
                              <label  >{strings?strings["pagado"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["pagado"]:""} 
                                    name="pagado"
                                    onChange={onChange}
                                    value={datos.pagado}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.metodoPagoId}>            
                              <label  >{strings?strings["metodoPagoId"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["metodoPagoId"]:""} 
                                    name="metodoPagoId"
                                    onChange={onChange}
                                    value={datos.metodoPagoId}
                                    icon='edit'/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/pagoss">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default PagosForm;